import React, { useState, useEffect, useRef, useCallback } from "react";
import LoanDataService from "../services/LoanService";
import { Link, useParams, useNavigate } from 'react-router-dom';
import TransactionTable from "../../components/TransactionTable";

const LoanList = (props) => {
  const [loans, setLoans] = useState([]);
  const loansRef = useRef();
  loansRef.current = loans;

  let { owner } = useParams();

  const retrieveLoans = useCallback((ownerParam) => {
    const target = ownerParam ?? owner;
    LoanDataService.getAll(target)
      .then((response) => {
        const payload = response?.data ?? response;
        const rows = payload?.data ?? payload?.loans ?? payload?.loan ?? payload;
        setLoans(Array.isArray(rows) ? rows : (rows ? [rows] : []));
      })
      .catch((e) => {
        console.error("LoanList.retrieveLoans error:", e?.response?.status, e?.response?.data || e?.message || e);
        setLoans([]);
      });
  }, [owner]);

  const navigate = useNavigate();
  useEffect(() => {
    retrieveLoans();
  }, [retrieveLoans]);

  const deleteLoan = useCallback((rowIndex) => {
    const id = loansRef.current[rowIndex].id || loansRef.current[rowIndex]._id;
    // pass owner if present so service can use owner/:id endpoint when needed
    LoanDataService.remove(id, owner)
      .then(() => {
        if (props?.history?.push) props.history.push("dashboard/loan");
        const newLoans = [...loansRef.current];
        newLoans.splice(rowIndex, 1);
        setLoans(newLoans);
      })
      .catch((e) => {
        console.error("deleteLoan error:", e?.response?.status || e?.message || e);
      });
  }, [props.history, owner]);

  const handleView = useCallback((row) => {
    const id = row.id || row._id;
    if (id && props?.history?.push) props.history.push(`/dashboard/loan/${id}`);
  }, [props.history]);

  const handleEdit = useCallback((row) => {
    const id = row.id || row._id;
    if (id && props?.history?.push) props.history.push(`/dashboard/loan/edit/${id}`);
  }, [props.history]);

  const handleDeleteRow = useCallback((row) => {
    const idx = loansRef.current.findIndex(item => (item.id || item._id) === (row.id || row._id));
    if (idx >= 0) deleteLoan(idx);
  }, [deleteLoan]);

  return (
    <div className="list row">
      <div className="col-md-12 list">
        <TransactionTable
          transactions={loans}
          accountType="loan"
          onView={handleView}
          onEdit={handleEdit}
          onDelete={handleDeleteRow}
          initialPageSize={10}
          showBack={true}
          onBack={() => navigate(-1)}
        />
      </div>

      <div className="col-md-8">
        <Link to={`/dashboard/loan/add/${owner || ""}`}>
           <button className="btn btn-sm btn-danger">Add Loan Transaction</button>
        </Link>
      </div>
    </div>
  );
};

export default LoanList;
